<template>
    <div class="auth-button" style="padding-left: 0.2rem; padding-right: 0.2rem;">

        <!-- Refer & Earn — full text (>1100px) -->
        <p-button
        v-if="getUserId"
        label="Refer &amp; Earn"
        class="refer-earn-btn refer-earn-text toptool-bold-font"
        icon="pi pi-money-bill"
        v-tooltip.bottom="'Refer &amp; Earn'"
        @click="goToReferral"
        />

        <!-- Refer & Earn — icon only (615px–1100px) -->
        <p-button
        v-if="getUserId"
        class="refer-earn-btn refer-earn-icon toptool-bold-font"
        icon="pi pi-money-bill"
        v-tooltip.bottom="'Refer &amp; Earn'"
        type="button"
        @click="goToReferral"
        />

        <p-button
        v-if="getUserId"
        label="Logout"
        class="p-button-secondary p-button-outlined large-auth-button"
        icon="pi pi-sign-out"
        @click="logoutAndNavigate"
        />
        <p-button
        v-else
        label="Login"
        class="p-button-secondary p-button-outlined large-auth-button"
        icon="pi pi-sign-in"
        @click="logInRoute"
        />

        <p-button
        v-if="getUserId"
        class="p-button-secondary p-button-outlined small-auth-button"
        icon="pi pi-sign-out"
        v-tooltip.left="'Logout'"
        type="button"
        @click="logoutAndNavigate"
        />
        <p-button
        v-else
        class="p-button-secondary p-button-outlined small-auth-button"
        icon="pi pi-sign-in"
        v-tooltip.left="'Login'"
        type="button"
        @click="logInRoute"
        />


        <LoginModal :visible.sync="isLoginModal" @toggleModal="loginModalClose" />
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import LoginModal from '../Modals/Auth/LoginModal.vue';
import { LogoutAPI } from '../../services/user';

export default {
    name: "AuthButton",
    data() {
        return {
        }
    },
    components: {
        LoginModal
    },
    methods: {
        ...mapMutations(['SET_LOGIN_MODAL']),
        loginModalClose() {
            this.SET_LOGIN_MODAL(false)
        },
        logInRoute() {
            this.SET_LOGIN_MODAL(true)
        },
        async logoutAndNavigate() {
            await LogoutAPI();
            localStorage.removeItem('state')
            localStorage.removeItem('stripeSession')
            localStorage.removeItem('GuruRequests')
            localStorage.removeItem('ScanRequests')
            localStorage.removeItem('themeDarkModeSave')
            this.$store.commit('RESET_STATE', true)
            location.reload()
        },
        goToReferral() {
            this.$router.push({ name: 'ReferAndEarn' })
        },
    },
    computed: {
        ...mapGetters([
            'getUserId',
            'isLoginModal'
        ])
    }
}
</script>

<style lang="scss" scoped>
.refer-earn-btn {
    background-color: #16a34a !important;
    border: 1px solid #16a34a !important;
    color: #ffffff !important;
    margin-right: 2px;
    box-shadow: none !important;

    transition:
        background-color 0.2s,
        border-color 0.2s,
        box-shadow 0.2s !important;

    &:hover {
        background-color: #15803d !important;
        border-color: #15803d !important;
        color: #ffffff !important;
    }

    &:active {
        background-color: #166534 !important;
        border-color: #166534 !important;
    }

    /* money icon style */
    :deep(.p-button-icon) {
        color: #ffffff !important;
    }

    :deep(.p-button-label) {
        color: #ffffff !important;
    }
}
/* ─── Responsive visibility for Refer & Earn ─────────────────────────
   >1100px  → full labeled button (refer-earn-text)
   615–1100px → icon-only button (refer-earn-icon)
   <615px   → existing small-auth-button icon takes over
──────────────────────────────────────────────────────────────────── */
.refer-earn-text { display: inline-flex; }
.refer-earn-icon { display: none; }

@media screen and (max-width: 1300px) {
    .refer-earn-text { display: none !important; }
    .refer-earn-icon { display: inline-flex !important; }
}
.auth-button {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    justify-content: flex-start !important;
    gap: 0.3rem !important; /* Perfect professional spacing between yellow $ and Logout buttons */
}
/* Ensure the Logout/Login button remains inline in the flex container */
.large-auth-button {
    display: inline-flex !important;
}
.small-auth-button {
    display: none !important; /* Hidden on desktop */
}
/* Swap visibility on mobile/tablets */
@media screen and (max-width: 615px) {
    .large-auth-button {
        display: none !important; /* Hidden on mobile */
    }
    .small-auth-button {
        display: inline-flex !important; /* Visible on mobile */
  
    }
}
/* Below 615px: hide both custom ones, small-auth-button handles it */
// @media screen and (max-width: 615px) {
//     .refer-earn-icon { display: none; }
// }
</style>